import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, Output } from '@angular/core';

@Component({
  selector: 'app-filtro-buscar',
  templateUrl: './filtro-buscar.component.html',
  styleUrls: ['./filtro-buscar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FiltroBuscarComponent implements OnDestroy {

  @Output() buscador: EventEmitter<string> = new EventEmitter();

  public interval: any;

  constructor() { }

  public buscarInformacion(value: any): void {

    if (!['', null, undefined].includes(value)) { }
      this.buscador.emit(value);
  }

  // @HostListener('window:input')
  // private inputEvent(): void {

  //   const inputBuscar = document.getElementById('input-buscar');

  //   const inputBuscar$ = fromEvent(inputBuscar, 'input').pipe(
  //     debounceTime(1000),
  //     map((event: any) => event.target.value)
  //   );

  //   this.subs.add(inputBuscar$.subscribe({
  //     next: value => {
  //     },
  //   })
  //   );
  // }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

}
